/**
 * 设置页面 - 参考 openlink.chat 设计风格
 */

import { useAuthStore } from '../../store/authStore';
import { logout } from '../../api/auth';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

export default function Settings() {
  const { user } = useAuthStore();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    toast.success('已安全登出');
    navigate('/login');
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="flex items-center gap-3 mb-8">
        <a href="/dashboard" className="text-gray-400 hover:text-gray-600" onClick={(e) => { e.preventDefault(); navigate('/dashboard'); }}>
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </a>
        <h1 className="text-3xl font-bold text-gray-900">账号设置</h1>
      </div>

      {/* 基本信息 */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 mb-6">
        <div className="px-6 py-4 border-b border-gray-200">
          <h2 className="text-lg font-bold text-gray-900">基本信息</h2>
        </div>
        <div className="p-6 space-y-4">
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-500 mb-1">用户名</label>
              <div className="text-gray-900 font-medium">{user?.nickname || user?.email || '未设置'}</div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-500 mb-1">邮箱</label>
              <div className="text-gray-900 font-medium">{user?.email || '未设置'}</div>
            </div>
          </div>
        </div>
      </div>

      {/* 账户安全 */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 mb-6">
        <div className="px-6 py-4 border-b border-gray-200">
          <h2 className="text-lg font-bold text-gray-900">账户安全</h2>
        </div>
        <div className="p-6">
          <button className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 font-medium text-sm">
            修改密码
          </button>
        </div>
      </div>

      {/* 危险区域 */}
      <div className="bg-white rounded-xl shadow-sm border border-red-200">
        <div className="px-6 py-4 border-b border-red-200">
          <h2 className="text-lg font-bold text-red-600">危险区域</h2>
        </div>
        <div className="p-6">
          <p className="text-sm text-gray-600 mb-4">
            登出将清除本地登录状态，需要重新登录才能访问。
          </p>
          <button
            onClick={handleLogout}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 font-medium text-sm"
          >
            退出登录
          </button>
        </div>
      </div>
    </div>
  );
}
